(() => {
  'use strict';

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-marketing-event]');
    if (!link) return;

    const detail = {
      event: link.dataset.marketingEvent,
      contentId: link.dataset.contentId || '',
      destination: link.getAttribute('href') || '',
      page: window.location.pathname
    };

    /* Privacy-first integration point: no identifiers, cookies, or network request. */
    window.dispatchEvent(new CustomEvent('durazevis:aggregate-event', { detail }));
  });
})();
